export const GET_LAYOUT_PRESETS = "GET_LAYOUT_PRESETS";
export const GET_LAYOUT_PRESET_BY_ID = "GET_LAYOUT_PRESET_BY_ID";
export const UPDATE_LAYOUT_PRESET = "UPDATE_LAYOUT_PRESET";
export const DELETE_LAYOUT_PRESET = "DELETE_LAYOUT_PRESET";
export const CREATE_LAYOUT_PRESET = "CREATE_LAYOUT_PRESET";
